import React, { FunctionComponent } from 'react';
import { BrowserView as RddBrowserView, MobileView as RddMobileView } from 'react-device-detect';
import config from '../../configs/appConfig.json';

// Si config.allowMobile es true, el contenido de escritorio se muestra también
// en móvil y las vistas "no apto para móvil" (MobileView) se ocultan.
const allowMobile = (config as { allowMobile?: boolean }).allowMobile === true;

export const BrowserView: FunctionComponent<any> = ({ children, ...rest }) =>
  allowMobile ? <>{children}</> : <RddBrowserView {...rest}>{children}</RddBrowserView>;

export const MobileView: FunctionComponent<any> = ({ children, ...rest }) =>
  allowMobile ? null : <RddMobileView {...rest}>{children}</RddMobileView>;
